export const hasPermission = (
  permissions: Record<string, string[]> | undefined,
  module: string,
  action: string = "view"
): boolean => {
  if (!permissions || !permissions[module]) return false;
  return permissions[module].includes(action);
};

export const isTenantAdminUser = (user: any): boolean =>
  user?.role === "admin" || user?.roleDetails?.name?.toLowerCase() === "admin";

// Same rule the backend's requirePermission enforces: Admin can do
// everything, anyone else needs the action listed under the module.
export const userCan = (user: any, module: string, action: string = "view") =>
  isTenantAdminUser(user) ||
  hasPermission(user?.roleDetails?.permissions || user?.permissions, module, action);
